/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import AccountsNavBar from '../../../../layouts/accounts/AccountsNavBar';
import AccountsLteBody from './AccountsLteBody';

const AccountsLte = () => {
  const { profile, user } = useUser();
  const { firstName } = profile;

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AccountsNavBar currentPage="Clean LTE" roleID={user.role_id} position={firstName} />
        <AccountsLteBody />
      </main>
    </div>
  );
};

export default AccountsLte;
